module.exports = __webpack_public_path__ + "static/media/wizualizacja-146.4c768a90.png";